import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '$partials/ui';
import { useLanguage } from '$contexts/language.jsx';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const JobItem = ({
    __typename             = null,
    alternate              = null,
    applyOnlineLink        = null,
    audiences              = null,
    company_id             = null,
    company_name           = null,
    employmentTypes        = null,
    externalPostingName    = null,
    geo_city               = null,
    geo_country            = null,
    geo_lat                = null,
    geo_long               = null,
    geo_name               = null,
    geo_state              = null,
    geo_street             = null,
    geo_zip                = null,
    industries             = null,
    internal_reference_id  = null,
    internalJobAdText      = null,
    internalPostingName    = null,
    job_ad_url             = null,
    job_owner_avatarurl    = null,
    job_owner_city         = null,
    job_owner_email        = null,
    job_owner_firstname    = null,
    job_owner_function     = null,
    job_owner_lastname     = null,
    job_owner_phone        = null,
    job_owner_salutation   = null,
    job_owner_street       = null,
    job_owner_title        = null,
    job_owner_zip          = null,
    jobAdText              = null,
    jobCategories          = null,
    jobDbId                = null,
    jobStartDate           = null,
    keywords               = null,
    layoutId               = null,
    locale                 = null,
    postingLastUpdatedDate = null,
    project_number         = null,
    remote_status          = null,
    workExperiences        = null,
    workTimes              = null
}) => {
    // hooks
    const {
        current: localeCurrent,
        translate: t
    } = useLanguage();

    // render
    return (
        <div className='expand-interaction'>
            <dl>
                {/* role */}
                <dt className='accessible-hide'>
                    {t('Role')}
                </dt>

                {externalPostingName && (
                    <dd className='pb3 pt4 border-bottom border-black'>
                        <h4 className='type-style-3'>
                            {externalPostingName}
                        </h4>
                    </dd>
                )}

                {/* location */}
                <dt className='accessible-hide'>
                    {t('Location')}
                </dt>

                {(geo_city && geo_country) && (
                    <dd className='type-style-6 pb3 pt4 border-bottom border-black hans-purple'>
                        <span>
                            {geo_city}
                        </span>

                        <span>
                            , {geo_country}
                        </span>
                    </dd>
                )}

                {/* link */}
                <div className='pt6 sm-pt6 md-pt7'>
                    <Button
                        className='button expand-interaction__action'
                        href={`/${localeCurrent === 'en' ? `join/${jobDbId}` : `${localeCurrent}/join/${jobDbId}`}`}>
                        <span className='type-style-6 capitalise'>
                            {t('Apply')}
                        </span>
                    </Button>
                </div>
            </dl>
        </div>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

JobItem.propTypes = {
    __typename            : PropTypes.string,
    alternate             : PropTypes.string,
    applyOnlineLink       : PropTypes.string,
    audiences             : PropTypes.array,
    company_id            : PropTypes.string,
    company_name          : PropTypes.string,
    employmentTypes       : PropTypes.array,
    externalPostingName   : PropTypes.string,
    geo_city              : PropTypes.string,
    geo_country           : PropTypes.string,
    geo_lat               : PropTypes.string,
    geo_long              : PropTypes.string,
    geo_name              : PropTypes.string,
    geo_state             : PropTypes.string,
    geo_street            : PropTypes.string,
    geo_zip               : PropTypes.string,
    industries            : PropTypes.array,
    internal_reference_id : PropTypes.string,
    internalJobAdText     : PropTypes.string,
    internalPostingName   : PropTypes.string,
    job_ad_url            : PropTypes.string,
    job_owner_avatarurl   : PropTypes.string,
    job_owner_city        : PropTypes.string,
    job_owner_email       : PropTypes.string,
    job_owner_firstname   : PropTypes.string,
    job_owner_function    : PropTypes.string,
    job_owner_lastname    : PropTypes.string,
    job_owner_phone       : PropTypes.string,
    job_owner_salutation  : PropTypes.string,
    job_owner_street      : PropTypes.string,
    job_owner_title       : PropTypes.string,
    job_owner_zip         : PropTypes.string,
    jobAdText             : PropTypes.string,
    jobCategories         : PropTypes.array,
    jobDbId               : PropTypes.number,
    jobStartDate          : PropTypes.number,
    keywords              : PropTypes.string,
    layoutId              : PropTypes.string,
    locale                : PropTypes.string,
    postingLastUpdatedDate: PropTypes.number,
    project_number        : PropTypes.string,
    remote_status         : PropTypes.string,
    workExperiences       : PropTypes.array,
    workTimes             : PropTypes.array
};

JobItem.__typename = 'Job';

export { JobItem };

export default JobItem;
